import axios from 'axios';

export const getCookie = (name: string) => {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === name + '=') {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
};

export const sendGetRequest = async (
  url: string,
  token: string | null = null
) => {
  try {
    let headers: any = {};
    if (token) headers['Authorization'] = `Token ${token}`;
    return (await axios.get(url, { headers: headers })).data;
  } catch (e) {
    return Promise.reject(e);
  }
};

export const sendPostRequest = async (
  url: string,
  body: object,
  token: string | null = null
) => {
  try {
    let headers: any = {};
    if (token) headers['Authorization'] = `Token ${token}`;
    return (
      await axios.post(url, body, {
        headers: headers,
      })
    ).data;
  } catch (error: any) {
    return Promise.reject(error.response.data);
  }
};

export const sendDeleteRequest = async (
  url: string,
  token: string | null = null
) => {
  try {
    let headers: any = {};
    if (token) headers['Authorization'] = `Token ${token}`;
    return (
      await axios.delete(url, {
        headers: headers,
      })
    ).data;
  } catch (error: any) {
    return Promise.reject(error.response.data);
  }
};

export const validateSearchParameter = {
  isNumber: (param: string | null) => {
    if (param === null) return false;

    const num = Number(param);
    if (isNaN(num)) return false;

    return Number.isInteger(num);
  },
};


export const sendPatchRequest = async (
  url: string,
  body: object,
  token: string | null = null
) => {
  try {
    let headers: any = {};
    if (token) headers['Authorization'] = `Token ${token}`;
    return (
      await axios.patch(url, body, {
        headers: headers,
      })
    ).data;
  } catch (error: any) {
    return Promise.reject(error.response.data);
  }
};
